module.exports = __webpack_public_path__ + "assets/images/estimatedTime-1738f2457b94df1d47e89057a5126a91.png";